import { parseVideoTime, videoTime } from "../lib/videoSelection";

export function VideoRangePicker({ durationS, start, end, onChange, problem, locked = false }: {
  durationS: number | null;
  start: string;
  end: string;
  onChange: (start: string, end: string) => void;
  problem: string | null;
  locked?: boolean;
}) {
  const s = parseVideoTime(start);
  const e = parseVideoTime(end);
  return (
    <fieldset className="video-range" id="bq-range" data-testid="video-range" aria-describedby="video-range-help video-range-status">
      <legend>Choose the part to analyse</legend>
      <p className="tiny" id="video-range-help">{durationS !== null ? `This video is ${videoTime(durationS)} long. ` : ""}Choose up to 4 hours.</p>
      <div className="video-range-fields">
        <label className="bq-lbl">Start
          <input className={`field bq-field${problem ? " invalid" : ""}`} type="text" placeholder="00:00:00" value={start}
            onChange={(e) => onChange(e.target.value, end)} readOnly={locked} aria-invalid={!!problem} aria-describedby="video-range-format video-range-status" data-testid="video-range-start" />
        </label>
        <label className="bq-lbl">End
          <input className={`field bq-field${problem ? " invalid" : ""}`} type="text" placeholder="04:00:00" value={end}
            onChange={(e) => onChange(start, e.target.value)} readOnly={locked} aria-invalid={!!problem} aria-describedby="video-range-format video-range-status" data-testid="video-range-end" />
        </label>
      </div>
      <p className="tiny mt8" id="video-range-format">Hours : minutes : seconds</p>
      <p className={`${problem ? "err" : "tiny"} mt12`} id="video-range-status" role="status" aria-live="polite" data-testid="video-range-status">
        {problem ?? (s !== null && e !== null ? `${videoTime(e - s)} selected · up to 4 hours` : "")}
      </p>
      <p className="tiny mt8">{locked ? "Your interrupted upload will resume with this part." : "The full file uploads; only this part is analysed."}</p>
    </fieldset>
  );
}
